import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useLocation, Navigate } from 'react-router-dom';

import Loading from 'components/Loading';
import axios from 'util/Api';

export default function RejectInvite() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { key } = queryString.parse(location.search);

  const reject = async () => {
    setLoading(true);

    // eslint-disable-next-line no-useless-catch
    try {
      await axios.post(`/api/v1/invitations`, {
        key,
        accepted: false,
      });
    } catch (e) {
      throw e;
    }

    setLoading(false);
  };

  useEffect(() => {
    reject();
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Navigate
          to={{
            pathname: '/',
            state: { from: location },
          }}
        />
      )}
    </>
  );
}
